import React, { Component } from 'react';
import PropTypes from 'prop-types';
import form from '../../hocs/form';

class Form extends Component {
  static propTypes = {
    getValues: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateAll: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
    hideError: PropTypes.func.isRequired
  };

  render() {
    const { getValues, validate, validateAll, showError, hideError, ...props } = this.props;

    return <form className="form" {...props} />;
  }
}

export default form(Form);



// WEBPACK FOOTER //
// ./src/components/layouts/react-validation/components/form/index.js